
//鼠标经过预览图片函数
function preview(img){
	jQuery("#preview .jqzoom img").attr("src",jQuery(img).attr("src"));
	jQuery("#preview .jqzoom img").attr("jqimg",jQuery(img).attr("bimg"));
}
//图片放大镜效果
jQuery(function(){
	jQuery(".jqzoom").jqueryzoom({xzoom:400,yzoom:400});
});

//图片预览小图移动效果,页面加载时触发
jQuery(function(){
	var tempLength = 0; //临时变量,当前移动的长度
	var viewNum = 5; //设置每次显示图片的个数量
	var moveNum = 2; //每次移动的数量
	var moveTime = 300; //移动速度,毫秒
	  
	//下一张
	jQuery(".spec-scroll .next").bind("click",function(){
		var scrollDiv = jQuery(".spec-scroll .items ul"); //进行移动动画的容器
		var scrollItems = jQuery(".spec-scroll .items ul li"); //移动容器里的集合
		var moveLength = scrollItems.eq(0).width() * moveNum; //计算每次移动的长度
		var countLength = (scrollItems.length - viewNum) * scrollItems.eq(0).width(); //计算总长度,总个数*单个长度		
		if(tempLength < countLength){
			if((countLength - tempLength) > moveLength){
				scrollDiv.animate({left:"-=" + moveLength + "px"}, moveTime);
				tempLength += moveLength;
			}else{
				scrollDiv.animate({left:"-=" + (countLength - tempLength) + "px"}, moveTime);
				tempLength += (countLength - tempLength);
			}
		}
	});
	//上一张
	jQuery(".spec-scroll .prev").bind("click",function(){
		var scrollDiv = jQuery(".spec-scroll .items ul"); //进行移动动画的容器
		var scrollItems = jQuery(".spec-scroll .items ul li"); //移动容器里的集合
		var moveLength = scrollItems.eq(0).width() * moveNum; //计算每次移动的长度
		var countLength = (scrollItems.length - viewNum) * scrollItems.eq(0).width(); //计算总长度,总个数*单个长度				
		if(tempLength > 0){
			if(tempLength > moveLength){
				scrollDiv.animate({left: "+=" + moveLength + "px"}, moveTime);
				tempLength -= moveLength;
			}else{
				scrollDiv.animate({left: "+=" + tempLength + "px"}, moveTime);
				tempLength = 0;
			}
		}
	});
});
jQuery(function(){
//tab
	jQuery(".sp-dt-tab .hd ul li").click(function(){
		var index=jQuery(this).index();
		jQuery(this).addClass("hover").siblings().removeClass();
		jQuery(".sp-dt-tab .bd").eq(index).show().siblings(".sp-dt-tab .bd").hide();
		})
	//省市选择
	jQuery(".sw-ui-area-box").hide(); 
	jQuery('.sw-ui-area-box-item a').click(function(){
		if(jQuery(this).attr("c").length > 1)
		{
		  var citys = jQuery(this).attr("p")+" "+jQuery(this).attr("c");
		  //alert(citys);
		  jQuery("#citys").text(citys); 
		  jQuery(".sw-ui-area-box").hide();  
		}
	 });
	 //全部商品
//	 jQuery(".mall-categorys .hd").click(function(){
//		 jQuery(".sc-submenu").show();
//		 });
//	 jQuery(".sc-submenu").mouseleave(function(){
//		 jQuery(this).hide();
//		 });
})


// WEBPACK FOOTER //
// ./static/js/jqzoom.base.js